const LOCAL_API_URL = 'http://localhost/api';
const STAGING_API_URL = 'https://staging.apiapostatudo.com/api';
const STAGING_2_API_URL = 'https://staging-2.apiapostatudo.com/api';
const PRODUCTION_API_URL = 'https://apiapostatudo.com/api';

export function getApostatudoApiUrl() {
  const host = window.location.hostname;

  const mapping = [
    { match: 'localhost', url: LOCAL_API_URL },
    // homolog-3 e homolog-4 precisam vir antes do match genérico de homolog,
    // que também casa com o sufixo numerado.
    { match: 'apostatudo-bet-br-homolog-3', url: STAGING_2_API_URL },
    { match: 'apostatudo-bet-br-homolog-4', url: STAGING_2_API_URL },
    { match: 'apostatudo-bet-br-homolog', url: STAGING_API_URL },
    { match: 'apostatudo.bet', url: PRODUCTION_API_URL },
  ];

  const entry = mapping.find((env) => host.includes(env.match));

  if (!entry) {
    console.error(
      `[getApostatudoApiUrl] - No API URL mapping found for host: ${host}`,
    );
  }

  return entry ? entry.url : 'http://localhost/api';
}
